import { Component } from 'react'
import { PHONE_DISPLAY, PHONE_TEL } from '../lib/constants'

/**
 * Last line of defence: without this, any render-time error unmounts the whole
 * React tree and the visitor sees a blank page with no way forward.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[True North] Page error:', error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div
        style={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '80px 24px',
          background: 'var(--color-panel)',
        }}
      >
        <div style={{ maxWidth: 640, textAlign: 'center' }}>
          <h1 style={{ margin: 0, fontSize: 'clamp(2rem, 3.6vw, 2.75rem)', color: 'var(--color-teal-900)' }}>
            Something went wrong on this page.
          </h1>
          <p style={{ margin: '20px 0 0 0', fontSize: 19, lineHeight: 1.7, color: 'var(--color-muted)' }}>
            Sorry about that. Reloading usually fixes it. If you need to reach us right away, please call our
            office — we're happy to help.
          </p>
          <div style={{ marginTop: 32, display: 'flex', flexWrap: 'wrap', gap: 16, justifyContent: 'center' }}>
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              Reload the page
            </button>
            <a href={PHONE_TEL} className="btn btn-secondary">
              Call {PHONE_DISPLAY}
            </a>
          </div>
          <p style={{ margin: '24px 0 0 0', fontSize: 15, color: 'var(--color-muted)' }}>
            Reference: {String(this.state.error?.message || this.state.error).slice(0, 120)}
          </p>
        </div>
      </div>
    )
  }
}
